/* tslint:disable */
/* eslint-disable */
/**
 * Контроль місій для FPV
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface InputUavMissionFlightParams
 */
export interface InputUavMissionFlightParams {
    /**
     * Altitude — текст, бо в заявках трапляються діапазони («200-2000»), а не лише одне число.
     * @type {string}
     * @memberof InputUavMissionFlightParams
     */
    altitude?: string;
    /**
     * FlightDate/TimeWindow — перенесення вильоту. Потрібне насамперед екіпажу: заплановане
     * «на завтра о 6:00» регулярно зсувається, і без правки лишалось би тільки завести заявку
     * заново. nil = не чіпаємо (поля опційні й незалежні одне від одного).
     * 
     * Зміна будь-якого з них перераховує active_until, а від нього залежить, у якому режимі
     * заявка видима (active/upcoming/history) — див. ComputeUavMissionActiveUntil.
     * @type {string}
     * @memberof InputUavMissionFlightParams
     */
    flightDate?: string;
    /**
     * SpeedKmh — км/год (перерахунок з м/с робить клієнт/парсер, у сервіс приходять км/год).
     * @type {number}
     * @memberof InputUavMissionFlightParams
     */
    speedKmh?: number;
    /**
     * 
     * @type {string}
     * @memberof InputUavMissionFlightParams
     */
    timeWindow?: string;
}

/**
 * Check if a given object implements the InputUavMissionFlightParams interface.
 */
export function instanceOfInputUavMissionFlightParams(value: object): boolean {
    return true;
}

export function InputUavMissionFlightParamsFromJSON(json: any): InputUavMissionFlightParams {
    return InputUavMissionFlightParamsFromJSONTyped(json, false);
}

export function InputUavMissionFlightParamsFromJSONTyped(json: any, ignoreDiscriminator: boolean): InputUavMissionFlightParams {
    if (json == null) {
        return json;
    }
    return {
        
        'altitude': json['altitude'] == null ? undefined : json['altitude'],
        'flightDate': json['flightDate'] == null ? undefined : json['flightDate'],
        'speedKmh': json['speedKmh'] == null ? undefined : json['speedKmh'],
        'timeWindow': json['timeWindow'] == null ? undefined : json['timeWindow'],
    };
}

export function InputUavMissionFlightParamsToJSON(value?: InputUavMissionFlightParams | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'altitude': value['altitude'],
        'flightDate': value['flightDate'],
        'speedKmh': value['speedKmh'],
        'timeWindow': value['timeWindow'],
    };
}

